import Vue from 'vue';
import SharedHelper from '@/Helpers/Shared';
export default {
  mixins: [SharedHelper],
  data() {
    return {
      transformedInformation: {
        basicInformation: {},
        patients: [],
        patientSituationExplaination: {},
        patientDrugsHistories: {},
        bodyExamination: {},
        fullBodyExamination: { front: [], back: [] },
        patientSignsAndActionsInformation: {
          signs: [],
          actions: {
            drugs: [],
            general: [],
          },
        },
        missionDescriptions: [],
      },
    };
  },
  methods: {
    transformInfo: function (data) {
      this.transformBaseInfo(data);
      this.transformPatients(data);
    },
    transformBaseInfo: function (data) {
      const { mission, phone, hospital } = data;
      const transformData = {
        creationDate: mission?.creationDate,
        address: mission?.address || '-',
        chiefComplaintText: mission?.chiefComplaintText || '-',
        chiefComplaintNote: mission?.chiefComplaintNote || '-',
        phoneNumber: phone?.phoneNumber || '-',
        phoneCode: phone?.code || '-',
        diagnosisTitle: mission?.diagnosis?.title || '-',
        hospital,
      };
      this.transformedInformation.basicInformation = transformData;
    },
    transformPatients: function (data) {
      const { patients } = data;
      const transformedPatients = [...(patients || [])]?.map(({ firstName, lastName, ...rest }) => {
        const fullName = firstName || lastName ? `${firstName} ${lastName}` : '--';
        return {
          fullName,
          ...rest,
        };
      });
      this.transformedInformation.patients = [...transformedPatients];
    },
    transformPatientInfo: function (data) {
      this.transformPatientSituationExplaination(data);
      this.transformPatientMedicalAndDrugHistory(data);
      this.transformPatientBodyExamination(data);
      this.transformPatientFullBodyExamination(data);
      this.transformPatientSignsInformation(data);
      this.transformPatientGeneralAndDrugsActions(data);
    },
    transformPatientSituationExplaination: function (data) {
      const { consciousnessLevel, respiration, airway, bloodCirculation } =
        data?.patientInitialAssessment;
      const { patientDetails, patientAccompanyingSymptoms } = data;
      const TransformedpatientDetails = [...patientDetails]?.map(({ typeOfEmergency, ...rest }) => {
        return {
          typeOfEmergencyTitle: typeOfEmergency?.title || '-',
          ...rest,
        };
      });
      const transformedPatientSituationExplainationData = {
        consciousnessLevelTitle: consciousnessLevel?.title || '-',
        respirationTitle: respiration?.title || '-',
        airwayTitle: airway?.title || '-',
        bloodCirculationTitle: bloodCirculation?.title || '-',
        patientDetails: TransformedpatientDetails,
        patientTechnicianReportNote: data?.patientTechnicianReport?.note,
        patientAccompanyingSymptoms,
      };
      this.transformedInformation.patientSituationExplaination =
        transformedPatientSituationExplainationData;
    },
    transformPatientMedicalAndDrugHistory: function (data) {
      const { patientMedicalHistories, patientDrugHistories, patientAllergyHistories } = data;
      const allergyDrugsHistory = [...patientAllergyHistories]?.filter(
        ({ isAllergic }) => isAllergic,
      );
      const noneAllergyDrugsHistory = [...patientAllergyHistories]?.filter(
        ({ isAllergic }) => !isAllergic,
      );
      // TODO ECG should add
      this.transformedInformation.patientDrugsHistories = {
        patientMedicalHistories,
        allergyDrugsHistory,
        noneAllergyDrugsHistory,
        patientDrugHistories,
      };
    },
    transformPatientBodyExamination: function (data) {
      const {
        hadHeartMonitoring,
        heartRhythm,
        skinTurgor,
        skinTemperature,
        skinExamination,
        pulseQuality,
        pulseRhythm,
        hasNystagmus,
        hasVaginalBleeding,
        hasEyeDeviation,
        heartSound,
      } = data?.patientMedicalExamination;
      const { patientParturitionDetail } = data;
      const { rightHand, leftHand, rightLeg, leftLeg } = data?.patientMovementAbility;

      const tranformedData = {
        hadHeartMonitoring: hadHeartMonitoring ? 'دارد' : 'ندارد',
        heartRhythmTitle: heartRhythm || '-',
        heartSoundTitle: heartSound?.title || '-',
        skinTurgorTitle: skinTurgor?.title || '-',
        skinTemperature: skinTemperature || '-',
        skinExaminationTitle: skinExamination?.title || '-',
        hasNystagmusTitle: hasNystagmus ? 'دارد' : 'ندارد',
        hasVaginalBleeding: hasVaginalBleeding ? 'دارد' : 'ندارد',
        hasEyeDeviationTitle: hasEyeDeviation ? 'دارد' : 'ندارد',
        pulseQualityTitle: pulseQuality?.title || '-',
        pulseRhythmTitle: pulseRhythm?.title || '-',
        rightHandStrength: rightHand ? '-' : '',
        leftHandStrength: leftHand ? '-' : '',
        rightLegStrength: rightLeg ? '-' : '',
        leftLegStrength: leftLeg ? '-' : '',
        patientParturitionDetail,
      };
      this.transformedInformation.bodyExamination = tranformedData;
      this.transformPatientRespiratorySoundExamination(data);
      this.transformPatientPupilExamination(data);
      this.transformPatientAbdominalExamination(data);
    },
    transformPatientRespiratorySoundExamination: function (data) {
      const {
        rightFineRale,
        leftCoarseRale,
        leftFineRale,
        leftSoundReduction,
        leftWheeze,
        rightCoarseRale,
        rightSoundReduction,
        rightWheeze,
      } = data?.patientRespiratorySoundDetail;
      const transformData = [
        {
          id: 1,
          title: 'رال فاین',
          right: rightFineRale,
          left: leftFineRale,
        },
        {
          id: 2,
          title: 'رال کورس',
          right: rightCoarseRale,
          left: leftCoarseRale,
        },
        {
          id: 3,
          title: 'ویز',
          right: rightWheeze,
          left: leftWheeze,
        },
        {
          id: 4,
          title: 'کاهش صدا',
          right: rightSoundReduction,
          left: leftSoundReduction,
        },
      ];

      this.transformedInformation.bodyExamination.patientRespiratorySoundDetailsList =
        transformData;
    },
    transformPatientAbdominalExamination: function (data) {
      const { patientAbdominalExamination } = data;
      const transformData = [...patientAbdominalExamination]?.map(
        ({ abdomenExaminations, ...rest }) => {
          const abdomenExaminationsTitle = [...abdomenExaminations]
            ?.map(({ title }) => title)
            ?.join(',');
          return {
            title: abdomenExaminationsTitle,
            ...rest,
          };
        },
      );
      this.transformedInformation.bodyExamination.patientAbdominal = transformData;
    },
    transformPatientPupilExamination: function (data) {
      const {
        leftDilate,
        leftMiotic,
        leftNoAnswer,
        leftNormal,
        rightDilate,
        rightMiotic,
        rightNoAnswer,
        rightNormal,
      } = data?.patientPupilExamination;
      const patientPupilExaminationsList = [
        {
          id: 1,
          title: 'نرمال',
          right: rightNormal,
          left: leftNormal,
        },
        {
          id: 2,
          title: 'دیلاته',
          right: rightDilate,
          left: leftDilate,
        },
        {
          id: 3,
          title: 'میوتیک',
          right: rightMiotic,
          left: leftMiotic,
        },
        {
          id: 4,
          title: 'بدون پاسخ',
          right: rightNoAnswer,
          left: leftNoAnswer,
        },
      ];
      this.transformedInformation.bodyExamination.patientPupilExaminationsList =
        patientPupilExaminationsList;
    },
    transformPatientFullBodyExamination: function (data) {
      const { patientBodyExaminations } = data;
      const coloredPatientBodyExmanination = [...patientBodyExaminations]?.map((item) => {
        return {
          ...item,
          color: this.getRandomRolor(),
        };
      });
      const backBodyExaminationData = [...coloredPatientBodyExmanination]?.filter(
        ({ isFront }) => !isFront,
      );
      const frontBodyExaminationData = [...coloredPatientBodyExmanination]?.filter(
        ({ isFront }) => isFront,
      );
      this.transformedInformation.fullBodyExamination.front = frontBodyExaminationData;
      this.transformedInformation.fullBodyExamination.back = backBodyExaminationData;
    },
    transformPatientSignsInformation: function (data) {
      this.transformedInformation.patientSignsAndActionsInformation.signs = [
        ...data?.patientVitalSigns,
      ]?.map(({ observationDate, ...rest }) => {
        const jalaliObservationDate = Vue.moment(observationDate).format('jYYYY/jMM/jDD-HH:mm');
        return {
          ...rest,
          observationDate: jalaliObservationDate,
        };
      });
    },
    transformPatientGeneralAndDrugsActions: function (data) {
      const { patientTechnicianDrugs, patientGeneralActions } = data;
      const transformData = [...patientTechnicianDrugs]?.map(({ id, dosage, drug, actionDate }) => {
        const jalaliActionDate = Vue.moment(actionDate).format('jYYYY/jMM/jDD-HH:mm');
        return {
          id,
          drugTitle: drug?.title || '-',
          dosage: dosage || '-',
          actionDate: jalaliActionDate || '-',
          drugGroupTitle: drug?.drugGroup?.title || '-',
        };
      });
      this.transformedInformation.patientSignsAndActionsInformation.actions.general = [
        ...patientGeneralActions,
      ]?.map(({ generalAction, ...rest }) => {
        return {
          ...rest,
          title: generalAction?.title,
        };
      });
      this.transformedInformation.patientSignsAndActionsInformation.actions.drugs = transformData;
    },
    // transform
    transformMissionDescription: function (data) {
      this.transformedInformation.missionDescriptions = [...data]?.map(
        ({ noteDate, user, ...rest }) => {
          const { firstName, lastName, userName, phoneNumber } = user;
          const authorFullName = firstName && lastName ? `${firstName} ${lastName}` : userName;
          const jalaliNoteDate = Vue.moment(noteDate).format('jYYYY/jMM/jDD-HH:mm');
          return {
            authorFullName,
            jalaliNoteDate,
            authorPhoneNumber: phoneNumber,
            ...rest,
          };
        },
      );
    },
  },
};
